export class FeeDetailDto {
}
